module.exports = __webpack_public_path__ + "static/media/in-review-empty-state.d50be4a9.svg";